export const MARKDOWN_EDITOR_ID = "codesandbox.editors.markdown";
